const testimonials = [
  {
    name: "Angela P.",
    location: "Decatur, GA",
    rating: 5,
    text: "I had a last-minute business trip to London in 5 days and my passport was expired. Fast Passport Center saved the day. Their team guided me through every step and I had my expedited passport in hand within 3 days. Couldn't believe how smooth it was.",
    service: "Emergency Passport",
  },
  {
    name: "Robert K.",
    location: "Avondale Estates, GA",
    rating: 5,
    text: "We planned a family vacation to Cancun and realized my wife's passport had expired. We live in Avondale Estates and didn't want to deal with downtown Atlanta traffic. Started online, shipped from the local UPS store, and had the renewal back in a week. Amazing service.",
    service: "Passport Renewal",
  },
  {
    name: "Natalie T.",
    location: "Clarkston, GA",
    rating: 5,
    text: "My daughter needed a passport for a school study abroad program. I had no idea where to start with the forms and the acceptance clerk visit. Fast Passport Center sent us a perfect checklist, told us exactly which clerk to visit near Clarkston, and handled the rest. Got it in 7 days.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function DecaturTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Decatur &amp; DeKalb County Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Decatur, Avondale Estates, Clarkston, Stone Mountain, and DeKalb County who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}